const API_BASE = import.meta.env.VITE_API || 'http://localhost:3000';

export interface SigningApiResponse {
  success: boolean;
  error?: string;
  [key: string]: any;
}

class NativeSigningApi {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${API_BASE}/api/v1/native-signing`;
  }

  async getSession(token: string): Promise<SigningApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async startSession(token: string): Promise<SigningApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/${token}/start`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async submitSignature(
    token: string,
    payload: {
      signature_data: string;
      initials_data: string;
      consent_given: boolean;
      field_values?: Record<
        string,
        {
          value: string;
          type: 'text' | 'date';
          coordinates: { x: number; y: number; width: number; height: number; page: number };
          signerId: string;
          signerEmail: string;
        }
      >;
    }
  ): Promise<SigningApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/${token}/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async downloadDocument(token: string): Promise<void> {
    // Direct download via browser
    window.open(`${this.baseUrl}/${token}/download`, '_blank');
  }

  async healthcheck(): Promise<SigningApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/healthcheck`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(`Health check failed: ${response.status}`);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export const nativeSigningApi = new NativeSigningApi();
